import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Euler Search. All rights reserved.</p>
      <ul>
        <li><a href="https://www.linkedin.com/in/alexanderyudaev/">Contact Us</a></li>
        <li><a href="https://embeddingstud.io/">Other Projects</a></li>
      </ul>
    </footer>
  );
};

export default Footer;
